window.addEventListener('load', function () {
  if (typeof gsap === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.config({ limitCallbacks: true });

  var outer      = document.getElementById('fcpOuter');
  var track      = document.getElementById('fcpTrack');
  var progress   = document.getElementById('fcpProgress');
  var hint       = document.getElementById('fcpHint');
  var shelfInner = document.getElementById('fcpShelfInner');
  var ghostText  = document.getElementById('fcpGhostText');
  var bgImgs     = Array.from(document.querySelectorAll('.fcp-bg__img'));
  var cards      = Array.from(document.querySelectorAll('.fcp-card'));

  if (!track || !outer || !cards.length) return;

  /* ── Store original bg srcs ── */
  bgImgs.forEach(function (img) {
    img.dataset.originalSrc = img.src;
  });

  /* ── Card entrance ── */
  gsap.fromTo(cards,
    { opacity: 0, y: 24 },
    { opacity: 1, y: 0, duration: 0.6, stagger: 0.07, ease: 'power2.out', delay: 0.2 }
  );

  /* ── Background switcher ── */
  var currentBgIndex = -1;

  function showBg(index) {
    if (index === currentBgIndex) return;
    currentBgIndex = index;
    bgImgs.forEach(function (img, i) {
      gsap.to(img, {
        opacity: i === index ? 0.5 : 0,
        duration: 0.5,
        ease: 'power2.inOut'
      });
    });
  }

  /* ── Ghost text ── */
  var ghostTl = null;
  function setGhostText(text) {
    if (!ghostText) return;
    if (ghostTl) ghostTl.kill();
    ghostTl = gsap.timeline();
    ghostTl
      .to(ghostText, { opacity: 0, duration: 0.2, ease: 'power2.in', onComplete: function () {
        ghostText.textContent = text;
      }})
      .to(ghostText, { opacity: 1, duration: 0.4, ease: 'power2.out' });
  }

  /* ── Build product shelf ── */
  var currentFocused = -1;
  var shelfTl = null;

  function buildShelf(cardEl) {
    var dataEls = cardEl.querySelectorAll('.fcp-card__product-data');

    if (shelfTl) shelfTl.kill();

    var existing = shelfInner.querySelectorAll('.fcp-product-row');

    var doRebuild = function () {
      shelfInner.innerHTML = '';
      if (!dataEls.length) return;

      dataEls.forEach(function (d, i) {
        var a = document.createElement('a');
        a.className = 'fcp-product-row';
        a.href = d.dataset.url;
        a.innerHTML =
          '<span class="fcp-product-row__index">0' + (i + 1) + '</span>' +
          '<span class="fcp-product-row__name">' + d.dataset.title + '</span>' +
          '<span class="fcp-product-row__price">' + d.dataset.price + '</span>';
        shelfInner.appendChild(a);
      });

      shelfTl = gsap.fromTo(
        shelfInner.querySelectorAll('.fcp-product-row'),
        { opacity: 0, x: -12 },
        { opacity: 1, x: 0, duration: 0.45, stagger: 0.09, ease: 'power2.out' }
      );
    };

    if (existing.length) {
      gsap.to(existing, {
        opacity: 0,
        x: 10,
        duration: 0.2,
        ease: 'power2.in',
        onComplete: doRebuild
      });
    } else {
      doRebuild();
    }
  }

  /* ── Focus card ── */
  function focusCard(index) {
    if (index === currentFocused) return;
    currentFocused = index;

    cards.forEach(function (card, i) {
      if (i === index) {
        card.classList.add('is-focused');
      } else {
        card.classList.remove('is-focused');
      }
    });

    var focusedCard = cards[index];
    showBg(index);
    setGhostText(focusedCard.dataset.title || '');
    buildShelf(focusedCard);
  }

  /* ── Determine focused index from current x translation ── */
  var GAP = 14;

  function getFocusedIndex(xVal) {
    var translated = Math.abs(xVal || 0);
    var accumulated = 0;

    for (var i = 0; i < cards.length; i++) {
      var half = cards[i].offsetWidth / 2;
      if (translated < accumulated + half) return i;
      accumulated += cards[i].offsetWidth + GAP;
    }
    return cards.length - 1;
  }

  /* ── Scroll distance: stop when LAST card reaches the focus position ── */
  function getScrollAmount() {
  var total = 0;
  for (var i = 0; i < cards.length - 1; i++) {
    total += cards[i].offsetWidth + GAP;
  }
  // Include overflow card if present
  var overflowCard = document.getElementById('fcpOverflowCard');
  if (overflowCard) {
    total += overflowCard.offsetWidth + GAP;
  }
  return -total;
}

  /* ── GSAP ScrollTrigger ── */
  var tween = gsap.to(track, {
    x: getScrollAmount,
    ease: 'none',
    scrollTrigger: {
      trigger: outer,
      start: 'top top',
      end: function () {
        return '+=' + Math.abs(getScrollAmount()) * 2;
      },
      scrub: 1.5,
      pin: true,
      pinSpacing: true,
      pinnedContainer: outer,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        if (progress) progress.style.width = (self.progress * 100) + '%';
        if (hint) {
          if (self.progress > 0.03) hint.classList.add('is-hidden');
          else hint.classList.remove('is-hidden');
        }
        var currentX = gsap.getProperty(track, 'x');
        focusCard(getFocusedIndex(currentX));
      }
    }
  });

  /* Focus first card immediately */
  focusCard(0);
  showBg(0);

  window.addEventListener('resize', function () {
    tween.scrollTrigger.refresh();
  });

  /* ── Touch support for mobile ── */
  var touchStartX = 0;
  var touchStartY = 0;

  outer.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  outer.addEventListener('touchmove', function (e) {
    var dx = Math.abs(e.touches[0].clientX - touchStartX);
    var dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > dy && dx > 8) e.preventDefault();
  }, { passive: false });
});